export const formatAddProjectToUserAdapter = ({ listProject }) => {
  return listProject
    .filter((item) => item?.new)
    .map((project) => ({
      id: project.id
    }))
}
